var startOfDay = require('../start_of_day/index.js')

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/start_of_today/index.js
// module id = 826
// module chunks = 0